import { useDispatch, useSelector } from "react-redux";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { currentPendingMainAgentChangeRequests } from "../../../redux/selector/mainAgentChangeRequestSelector";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import TopNavigationBar from "../../TopNavigationBar";
import { useEffect, useMemo, useState } from "react";
import { humanReadableDate } from "../../../app/utils";
import { APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, REQUEST_STATUS, ROUTE_PATH } from "../../../app/constants";
import { push } from "connected-react-router";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import ReviewForm from "../../../components/ReviewForm/ReviewForm";
import { Button, ErrorMark, MainSeparator, Paragraph } from "../../../components/RegularComponents";
import { ERROR_STRING } from "../../../app/errors";
import { setCurrentMainAgentChangeRequestReadyToSubmit } from "../../../redux/slice/primaryAgencyApplicationSlice";

export const MainAgentChangeRequestReview = (props) => {
    const {applicationMode} = props.match.params
    const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
    const {mainAgentChangeRequest} = useSelector(currentPendingMainAgentChangeRequests);
    const serverSaveRequest = useSelector(state => state.primaryAgencyApplication.serverRequestStatus)
    const licencingSubType = agencyApplication?.licencingSubType;
    const companyName = agencyApplication?.name;
    const applicationType = applicationTypeFromLicenceSubType(licencingSubType)
    const mainAgentTypeString = (applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) ? 'Principal Broker' : 'Compliance Officer';

    const dispatch = useDispatch();

    const [applicationSaveError, setApplicationSaveError] = useState(false);
    const [changeRequestData, setChangeRequestData] = useState(false);

    useEffect(() => {
      const data = mainAgentChangeRequest?.changeRequestData ?? {}
      setChangeRequestData(data);
    }, [mainAgentChangeRequest])

    const reasonReviewData = useMemo(() => {
        const currentAgentReviewString = changeRequestData?.isCurrentlyActiveAgent ? 
            `Yes, I am the current ${mainAgentTypeString} for ${companyName}` : "No";

        return (
            <ReviewForm
                fullSize
                data={{
                    [`Current ${mainAgentTypeString}`]: currentAgentReviewString,
                    [`Effective Date`]: humanReadableDate(changeRequestData?.effectiveDate),
                    [`Reason for the request`]: changeRequestData?.reasonForChange
                }}
            />
        )
    }, [changeRequestData, mainAgentTypeString, companyName])

    const handleSubmit = () => {
      // Main app + parent app has to be updated
      dispatch(setCurrentMainAgentChangeRequestReadyToSubmit());

      dispatch(saveBusinessLicenceApplicationData(
        applicationTypeFromLicenceSubType(licencingSubType), applicationMode))
        .then(() => {
          dispatch(
            push(
              `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_MAIN_AGENT_CHANGE_REQUEST_SUBMIT_CONFIRM}`
            )
          );
        })
        .catch((err) => {
          setApplicationSaveError(true);
        });
    }

    let stepCounter = 1;

    return (
    <div className="container">
        <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
        {/* Title */}
        <div className="row">
            <div className="col-xs-12 col-lg-8">
                <h1>{`${mainAgentTypeString} Change Request Review`}</h1>
            </div>
        </div>

        <div className="timeline row topMarginMedium">
          <ol>
            <li className="timeline-item col-md-12">
                <div className="step-content col-md-12 col-xs-12">
                    <span className="step-counter step-counter-circle">{stepCounter++}</span>
                    <div className="row">
                        <div className="col-lg-8">
                            <Paragraph
                                style={{ paddingTop: "10px" }}
                                id="broker-application-review-text"
                                text={["<h3>Application<h3>"]}
                            />
                            {reasonReviewData}
                        </div>
                    </div>
                </div>
            </li>
            <li className="timeline-item col-md-12">
                <div className="step-content col-md-12 col-xs-12">
                    <MainSeparator />
                    <span className="step-counter step-counter-circle">{stepCounter++}</span>
                    <div className="row">
                        <div className="col-lg-8">
                            <ReviewForm
                                fullSize
                                data={{
                                    [`New ${mainAgentTypeString} Email`]: changeRequestData?.nextMainAgentEmail,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </li>
          </ol>
        </div>

        <div className="row">
            <div className={"col-lg-4"}>
                <Button
                    id="change-reason-save-button"
                    style={{ margin: "0 10px 10px 0" }}
                    buttonType={"regular_primary"}
                    text="Submit"
                    onClick={handleSubmit}
                    showSpinner={!applicationSaveError && 
                        (serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
                    disabled={(serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
                />
                {applicationSaveError && ErrorMark()}
                {applicationSaveError && (
                <div className="ns-error-message help-block topMarginNormal">
                    <span className="ns-visually-hidden">Error:</span>
                    {ERROR_STRING.APPLICATION_SAVE_ERROR}
                </div>
                )}
            </div>
        </div>
    </div>
    );
}
